/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { deployDeployCreateDeployment } from "../funcs/deployDeployCreateDeployment.js";
import { deployDeployGetDeployment } from "../funcs/deployDeployGetDeployment.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import * as components from "../models/components/index.js";
import { unwrapAsync } from "../types/fp.js";

export class Deploy extends ClientSDK {
  /**
   * Create deployment
   *
   * @remarks
   * **INTERNAL** - This endpoint is internal and may change without notice.
   * Not recommended for production use.
   *
   * Creates a new deployment for a project using either a pre-built Docker image or build context.
   *
   * **Authentication**: Requires a valid api key with appropriate permissions.
   */
  async deployCreateDeployment(
    request: components.V1DeployCreateDeploymentRequestBody,
    options?: RequestOptions,
  ): Promise<components.V1DeployCreateDeploymentResponseBody> {
    return unwrapAsync(deployDeployCreateDeployment(
      this,
      request,
      options,
    ));
  }

  /**
   * Get deployment
   *
   * @remarks
   * **INTERNAL** - This endpoint is internal and may change without notice.
   * Not recommended for production use.
   *
   * Retrieves deployment information including status, error messages, and steps.
   *
   * **Authentication**: Requires a valid api key with appropriate permissions.
   */
  async deployGetDeployment(
    request: components.V1DeployGetDeploymentRequestBody,
    options?: RequestOptions,
  ): Promise<components.V1DeployGetDeploymentResponseBody> {
    return unwrapAsync(deployDeployGetDeployment(
      this,
      request,
      options,
    ));
  }
}
